export default Object.freeze({
  list: [],
  users: {},
  forms: {},
  visitorLogSettings: {},
  mobileSettings: {},
  supervisors: [],
});
